import React from 'react'

import { type HomepageContent } from '../../types'
import HomeLink from '../HomeLink/HomeLink'
import styles from './styles.module.scss'

type AnnouncementBarProps = {
  announcement: HomepageContent['announcement']
}

const AnnouncementBar = ({ announcement }: AnnouncementBarProps) => {
  if (!announcement.enabled) return null

  return (
    <aside className={styles.bar} aria-label="Featured insight">
      <div className={styles.content}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>{announcement.eyebrow}</span>
          <p className={styles.title}>{announcement.title}</p>
        </div>
        <HomeLink
          className={styles.cta}
          to={announcement.cta.url}
          tracking={{
            event: 'homepage_announcement_click',
            tagName: `Homepage announcement: ${announcement.title}`,
          }}
        >
          {announcement.cta.label}
        </HomeLink>
      </div>
      <img className={styles.image} src={announcement.image} alt="" />
      <div className={styles.imageOverlay} aria-hidden />
    </aside>
  )
}

export default AnnouncementBar
